var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "button",
      class: [
        _vm.buttonClass,
        { btnChecked: _vm.btnIsChecked },
        { buttonDeleteIsVisible: _vm.showDeleteBtn },
      ],
    },
    [
      _vm.type === "input"
        ? _c("div", { staticClass: "container-btn" }, [
            _c(
              "label",
              [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { value: _vm.valueInput },
                  on: {
                    change: function ($event) {
                      _vm.$emit("button:clicked", _vm.valueInput),
                        (_vm.btnIsChecked = !_vm.btnIsChecked)
                    },
                  },
                }),
                _c("svgicon", {
                  staticClass: "icon",
                  attrs: {
                    name: _vm.iconName,
                    color: "$primary01",
                    height: "65",
                    width: "auto",
                  },
                }),
              ],
              1
            ),
            _c("p", { staticClass: "text-medium blueDark" }, [
              _vm._v(_vm._s(_vm.$t(_vm.buttonTitle))),
            ]),
          ])
        : _vm.type === "button"
        ? _c(
            "div",
            {
              staticClass: "container-btn",
              on: { click: _vm.handleButtonClick },
            },
            [
              _c("svgicon", {
                staticClass: "icon",
                attrs: {
                  name: _vm.iconName,
                  color: "$primary01",
                  height: "50",
                  width: "auto",
                },
                on: {
                  click: function ($event) {
                    _vm.btnIsChecked = !_vm.btnIsChecked
                  },
                },
              }),
              _c("p", { staticClass: "text-medium blueDark" }, [
                _vm._v(_vm._s(_vm.$t(_vm.buttonTitle))),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.type === "input-txt"
        ? _c("div", { staticClass: "container-btn" }, [
            _c("label", [
              _c("input", {
                attrs: { type: "checkbox" },
                domProps: { value: _vm.valueInput },
                on: {
                  change: function ($event) {
                    _vm.$emit(
                      "button:clicked",
                      _vm.valueInput,
                      _vm.buttonTitle
                    ),
                      (_vm.btnIsChecked = !_vm.btnIsChecked)
                  },
                },
              }),
            ]),
            _c("div", { staticClass: "btn-txt" }, [
              _c("p", { staticClass: "text-medium blueDark" }, [
                _vm._v(_vm._s(_vm.$t(_vm.buttonTitle))),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.type === "input-multiSelect-txt"
        ? _c(
            "div",
            { staticClass: "container-btn multiselect grid" },
            [
              _c("label", [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { value: _vm.valueInput },
                  on: {
                    change: function ($event) {
                      _vm.$emit(
                        "button:clicked",
                        _vm.valueInput,
                        _vm.buttonTitle
                      ),
                        (_vm.btnIsChecked = !_vm.btnIsChecked)
                    },
                  },
                }),
              ]),
              _c("svgicon", {
                staticClass: "checkmark",
                attrs: {
                  name: "check-mark",
                  color: "white",
                  height: "16",
                  width: "auto",
                },
              }),
              _c("div", { staticClass: "btn-txt" }, [
                _c("p", { staticClass: "text-medium blueDark" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.buttonTitle)) + " "),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _vm.type === "buttonImg"
        ? _c(
            "div",
            {
              staticClass: "container-btn imgButton",
              attrs: { id: _vm.idButton },
            },
            [
              _c(
                "div",
                {
                  staticClass: "imgContainer",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("click:photo", _vm.idButton)
                    },
                  },
                },
                [
                  _vm.imgSrc
                    ? _c("img", { attrs: { src: _vm.imgSrc } })
                    : _c(
                        "div",
                        { staticClass: "containerSvg" },
                        [
                          _c("svgicon", {
                            staticClass: "icon",
                            attrs: {
                              name: "empty-damage",
                              color: "#231F20",
                              height: "33",
                              width: "33",
                            },
                          }),
                        ],
                        1
                      ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "containerDetails grid grid--ai-middle grid--jc-between",
                },
                [
                  _c("div", { staticClass: "container-ttiles" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "headline-medium-regular gray mg mg--l-2 mg--t-1 mg--b-1",
                      },
                      [_vm._v(_vm._s(_vm.$t(_vm.buttonTitle)))]
                    ),
                    _c(
                      "p",
                      { staticClass: "text-small gray mg mg--b-1 mg--l-2" },
                      [_vm._v(" " + _vm._s(_vm.$t(_vm.buttonSubtitle)))]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "svg-dots mg mg--r-1" },
                    [
                      _c("svgicon", {
                        attrs: {
                          name: "more-vertical",
                          color: "#566473",
                          height: "21",
                          width: "21",
                        },
                        on: { click: _vm.handleMoreOptions },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
      _vm.type === "buttonImg"
        ? _c(
            "div",
            {
              staticClass: "buttonDelete mg mg--t-1",
              attrs: { id: _vm.idButton },
            },
            [
              _c(
                "div",
                {
                  staticClass: "containerBtn",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("click:btnDelete", _vm.idButton)
                    },
                  },
                },
                [
                  _c("svgicon", {
                    staticClass: "icon",
                    attrs: {
                      name: "delete-trash",
                      color: "#EF4136",
                      height: "13",
                      width: "15",
                    },
                  }),
                  _c("p", { staticClass: "text-medium redVidid" }, [
                    _vm._v(_vm._s(_vm.$t("actions.suppress"))),
                  ]),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm.type === "imgRadio"
        ? _c(
            "div",
            {
              staticClass: "container-btn imgRadioBtn",
              attrs: { id: _vm.idButton },
            },
            [
              _c("label", [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { value: _vm.valueInput },
                  on: {
                    change: function ($event) {
                      return _vm.$emit(
                        "button:clicked",
                        _vm.valueInput,
                        _vm.buttonTitle
                      )
                    },
                  },
                }),
              ]),
              _c(
                "div",
                {
                  staticClass: "imgContainer",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("click:photo", _vm.idButton)
                    },
                  },
                },
                [
                  _vm.imgName
                    ? _c("img", { attrs: { src: _vm.getImgPath(_vm.imgName) } })
                    : _c(
                        "div",
                        { staticClass: "containerSvg" },
                        [
                          _c("svgicon", {
                            staticClass: "icon",
                            attrs: {
                              name: "empty-damage",
                              color: "#231F20",
                              height: "33",
                              width: "33",
                            },
                          }),
                        ],
                        1
                      ),
                ]
              ),
              _c("div", { staticClass: "container-title" }, [
                _c("p", { staticClass: "text-medium blueDark" }, [
                  _vm._v(_vm._s(_vm.$t(_vm.buttonTitle))),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.type === "input-incremental"
        ? _c(
            "div",
            { staticClass: "container-btn increment" },
            [
              _c("label", [
                _c("input", {
                  attrs: { type: "checkbox" },
                  domProps: { value: _vm.valueInput },
                  on: { change: _vm.handleOnClickIncremental },
                }),
              ]),
              _c("svgicon", {
                staticClass: "icon",
                attrs: {
                  name: _vm.iconName,
                  color: "$primary01",
                  height: "65",
                  width: "auto",
                },
              }),
              _c("p", { staticClass: "checkmark" }, [
                _vm._v(" " + _vm._s(_vm.quantitySelected)),
              ]),
              _c("p", { staticClass: "literal" }, [
                _vm._v(_vm._s(_vm.$t(_vm.buttonTitle))),
              ]),
              _c("div", { staticClass: "btnActions" }, [
                _c(
                  "button",
                  {
                    staticClass: "btnAction btnDecrement",
                    on: { click: _vm.handleOnDecrementValue },
                  },
                  [_c("span", { staticClass: "textBtn" }, [_vm._v("-")])]
                ),
                _c(
                  "button",
                  {
                    staticClass: "btnAction btnIncrement",
                    on: { click: _vm.handleOnIncrementValue },
                  },
                  [_c("span", { staticClass: "textBtn" }, [_vm._v("+")])]
                ),
              ]),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }